(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
  if (!customElements.get('soleil-announcements')) {
    customElements.define('soleil-announcements', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        this.controller?.abort();
        this.cancelTransition();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = this.savedIndex();
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.max(3000, Number(this.dataset.interval) || 8000);
        this.track = this.querySelector('.soleil-announcements__slides');
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', (event) => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        window.addEventListener('pageshow', (event) => {
          if (!event.persisted) return;
          this.hovered = this.matches(':hover');
          this.focused = this.contains(document.activeElement);
          this.show(this.savedIndex(), true);
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.show(index, true);
        }, options);
        document.addEventListener('shopify:block:deselect', (event) => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        }, options);
        this.motion.addEventListener('change', () => {
          this.show(this.index, true);
        }, options);
        this.show(this.index, true);
      }
      savedIndex() {
        try {
          const savedId = sessionStorage.getItem(this.dataset.sessionKey);
          const index = this.slides.findIndex(slide => slide.dataset.blockId === savedId);
          if (index >= 0) return index;
        } catch {}
        return Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      }
      cancelTransition() {
        this.transitionId = (this.transitionId || 0) + 1;
        this.animation?.cancel();
        this.animation = null;
        this.animating = false;
        clearTimeout(this.timer);
      }
      setActive(index) {
        this.slides.forEach((slide, position) => {
          const active = position === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        try {
          const blockId = this.slides[index]?.dataset.blockId;
          if (blockId) sessionStorage.setItem(this.dataset.sessionKey, blockId);
        } catch {}
      }
      async show(index, immediate = false) {
        if (!this.slides?.length || (this.animating && !immediate)) return;
        const nextIndex = (index + this.slides.length) % this.slides.length;
        const currentIndex = this.index;
        const instantly = immediate || this.motion.matches || nextIndex === currentIndex;
        this.cancelTransition();
        this.index = nextIndex;
        if (instantly) {
          this.setActive(nextIndex);
          this.schedule();
          return;
        }
        const transitionId = this.transitionId;
        const direction = index < currentIndex ? -1 : 1;
        const outgoing = this.slides[currentIndex];
        const incoming = this.slides[nextIndex];
        this.animating = true;
        this.track?.setAttribute('aria-live', 'off');
        outgoing.inert = true;
        const exitAnimation = outgoing.animate([
          { opacity: 1, transform: 'translateX(0)', offset: 0 },
          { opacity: 1, transform: 'translateX(' + (-6 * direction) + 'px)', offset: 0.18 },
          { opacity: 0, transform: 'translateX(' + (-24 * direction) + 'px)', offset: 0.85 },
          { opacity: 0, transform: 'translateX(' + (-24 * direction) + 'px)', offset: 1 }
        ], { duration: 480, easing: 'ease-in-out', fill: 'forwards' });
        this.animation = exitAnimation;
        try {
          await exitAnimation.finished;
          if (transitionId !== this.transitionId) return;
          this.setActive(nextIndex);
          exitAnimation.cancel();
          const enterAnimation = incoming.animate([
            { opacity: 0, transform: 'translateX(' + (24 * direction) + 'px)', offset: 0 },
            { opacity: 0, transform: 'translateX(' + (24 * direction) + 'px)', offset: 0.08 },
            { opacity: 1, transform: 'translateX(0)', offset: 1 }
          ], { duration: 450, easing: 'ease-out', fill: 'backwards' });
          this.animation = enterAnimation;
          await enterAnimation.finished;
          if (transitionId !== this.transitionId) return;
          enterAnimation.cancel();
          this.animation = null;
          this.animating = false;
          this.schedule();
        } catch {
          if (transitionId !== this.transitionId) return;
          this.animation?.cancel();
          this.animation = null;
          this.animating = false;
          this.setActive(this.index);
          this.schedule();
        }
      }
      schedule() {
        clearTimeout(this.timer);
        const stopped = this.dataset.autoplay !== 'true' || this.motion.matches || this.hovered || this.focused || this.editorSelected || document.hidden || this.animating || this.slides.length < 2;
        this.track?.setAttribute('aria-live', stopped ? 'polite' : 'off');
        if (!stopped) this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        this.cancelTransition();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('soleil-countdown-timer')) {
  class SoleilCountdownTimer extends HTMLElement {
    connectedCallback() {
      if (this.interval) return;
      const requested = Date.UTC(Number(this.dataset.year), Number(this.dataset.month) - 1, Number(this.dataset.day), Number(this.dataset.hour), Number(this.dataset.minute));
      const pacific = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      this.deadline = requested;
      for (let i = 0; i < 3; i++) {
        const parts = Object.fromEntries(pacific.formatToParts(this.deadline).map(part => [part.type, part.value]));
        const represented = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
        this.deadline += requested - represented;
      }
      this.display = this.querySelector('[data-time-display]');
      let details = this.querySelector('[data-launch-details]');
      if (!details) {
        details = document.createElement('div');
        details.setAttribute('data-launch-details', '');
        details.className = 'soleil-launch-details';
        this.append(details);
      }
      const launch = new Date(this.deadline);
      const options = { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' };
      const storeTime = document.createElement('p');
      storeTime.textContent = 'Launch: ' + new Intl.DateTimeFormat('en-US', { ...options, timeZone: 'America/Los_Angeles', timeZoneName: 'short' }).format(launch);
      const localTime = document.createElement('p');
      localTime.textContent = 'Your local time: ' + new Intl.DateTimeFormat('en-US', { ...options, timeZoneName: 'long' }).format(launch);
      details.replaceChildren(storeTime, localTime);
      this.launchDetails = details;
      this.content = this.closest('.countdown__content');
      this.launchButton = this.content && this.content.querySelector('.countdown__button');
      this.update();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
    }
    update() {
      const remaining = Math.max(0, this.deadline - Date.now());
      const values = { days: Math.floor(remaining / 86400000), hours: Math.floor(remaining / 3600000) % 24, minutes: Math.floor(remaining / 60000) % 60, seconds: Math.floor(remaining / 1000) % 60 };
      for (const [unit, value] of Object.entries(values)) this.querySelector('[date-' + unit + '-placeholder]').textContent = String(value).padStart(2, '0');
      this.display.classList.add('countdown__display--loaded');
      this.display.classList.toggle('countdown__display--visible', remaining > 0 || this.dataset.hideTimer !== 'true');
      this.display.classList.toggle('countdown__display--hidden', remaining === 0 && this.dataset.hideTimer === 'true');
      if (remaining === 0) {
        if (this.dataset.launchProduct && this.content && !this.launched) {
          this.launched = true;
          this.content.querySelector('.countdown__heading h2').textContent = 'Tuttio Frame Guards are out now.';
          const copy = document.createElement('p');
          copy.textContent = 'Limited stock. Grab your favorite color before it sells out.';
          this.content.querySelector('.countdown__richtext').replaceChildren(copy);
          if (this.launchButton) {
            this.launchButton.textContent = 'Shop frameguards';
            this.launchButton.setAttribute('href', this.dataset.launchProduct);
          }
          this.launchDetails.hidden = true;
          this.content.classList.add('soleil-launch-live');
        }
        const message = this.querySelector('[data-message-placeholder]');
        if (message) message.classList.add('countdown__timer-message--visible');
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }
  customElements.define('soleil-countdown-timer', SoleilCountdownTimer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
